<template>
  <div class="flex items-center border border-[#cbd5e1] rounded-lg my-2 bg-white"
    @click="handleContainerClick">
    <div class="flex flex-wrap items-center gap-1">
      <div v-for="(email, index) in emails" :key="index" class="flex items-center py-1 px-3
      text-md
        m-1 bg-[#f1f5f9] rounded-md"
           @click="editEmail(index)">
        {{ email }}
        <span class="cursor-pointer font-bold text-xs ml-1" @click.prevent="removeEmail(index)">
          <i class="pi pi-trash"></i>
        </span>
      </div>
      <input class="py-1 px-3 text-md m-1 rounded-md" type="text"
        id="email-input" ref="emailInput" :style="{ width: inputWidth + 'px' }"
        :placeholder="$t('ExternalUsersInviteComponent.externalInvites')"
        v-model="email" @keydown.delete="deleteEmail"
        @keydown.enter="addEmail" @keydown.space="addEmail" @blur="addEmail"/>
      <span ref="mirror"
        class="invisible absolute whitespace-pre px-3 text-md top-0 left-0">
        {{ email || $t('ExternalUsersInviteComponent.externalInvites') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExternalUsersInviteComponent',
  data() {
    return {
      email: '',
      inputWidth: 20,
    };
  },
  computed: {
    emails() {
      return this.$store.getters.getInviteEmails;
    },
  },
  watch: {
    email() {
      this.updateInputWidth();
    },
  },
  methods: {
    updateInputWidth() {
      this.$nextTick(() => {
        if (this.$refs.mirror) {
          this.inputWidth = this.$refs.mirror.offsetWidth + 10;
        }
      });
    },
    addEmail() {
      if (!this.email) {
        return;
      }
      const newEmails = this.email.split(',')
        .map((email) => email.trim()
          .toLowerCase());
      const validEmails = newEmails.filter((email) => this.validateEmail(email));
      this.$store.commit('addInviteEmail', validEmails);
      if (validEmails.length < newEmails.length) {
        const invalidEmails = newEmails.filter((email) => !this.validateEmail(email));
        this.email = invalidEmails.join(', ');
      } else {
        this.email = '';
      }
    },
    removeEmail(index) {
      this.$store.commit('removeInviteEmail', index);
    },
    editEmail(index) {
      this.email = this.emails[index];
      this.$store.commit('removeInviteEmail', index);
      this.$nextTick(() => {
        this.$refs.emailInput.focus();
      });
    },
    handleContainerClick(event) {
      const { target } = event;
      const isInput = target === this.$refs.emailInput;
      const isPillRemove = target.classList.contains('close');
      if (!isInput && !isPillRemove) {
        this.$refs.emailInput.focus();
      }
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    deleteEmail() {
      if (this.email === '' && this.emails.length > 0) {
        this.$store.commit('popInviteEmail');
        this.email = '';
      }
    },
  },
  mounted() {
    this.$refs.emailInput.focus();
    this.updateInputWidth();
  },
};
</script>
